var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHurtsLittleDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_1119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 35C28.2843 35 35 28.2843 35 20C35 11.7157 28.2843 5 20 5C11.7157 5 5 11.7157 5 20C5 28.2843 11.7157 35 20 35Z",
    fill: "#A2EE4E",
    stroke: "#A2EE4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 24.5C25.1512 26.2938 22.8876 27.5 20 27.5C17.1124 27.5 14.8487 26.2938 13.5 24.5",
    stroke: "#406B0F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.375 19.375C15.7557 19.375 16.875 18.2557 16.875 16.875C16.875 15.4943 15.7557 14.375 14.375 14.375C12.9943 14.375 11.875 15.4943 11.875 16.875C11.875 18.2557 12.9943 19.375 14.375 19.375Z",
    fill: "#406B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.625 19.375C27.0057 19.375 28.125 18.2557 28.125 16.875C28.125 15.4943 27.0057 14.375 25.625 14.375C24.2443 14.375 23.125 15.4943 23.125 16.875C23.125 18.2557 24.2443 19.375 25.625 19.375Z",
    fill: "#406B0F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_1119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHurtsLittleDefault);
export default __webpack_public_path__ + "static/media/hurts-little-default.a30f54bbb9ddba467e85586a59d5529d.svg";
export { ForwardRef as ReactComponent };